import useModuleAccess from "./useModuleAccess";
import { APP_MODULES } from "../constants/appModules";

/**
 * True when the EMS projects tree is on screen to pick a Plant / WBS /
 * revision with - i.e. the user has the EMS module, which is what mounts the
 * global side panel (see routing/GlobalOutlet.jsx) and the EMS Explorer page.
 *
 * The module headers (PV3, Structure, Piping) use this to show Project UID /
 * WBS UID / Rev. as read-only text on every tab: when the tree is there it
 * owns selection, so a second set of pickers in the header is just another
 * way to get the two out of sync. Users without EMS keep the editable
 * dropdowns, since the tree is the only other way in.
 */
export default function useEmsTreeAvailable() {
  const { hasModule } = useModuleAccess();
  return hasModule(APP_MODULES.EMS);
}
